import { IResources } from "@/types/public";

import translationEN from "./locales/en.json";
import translationFA from "./locales/fa.json";

export const resources: IResources = {
  en: {
    translation: translationEN,
  },
  fa: {
    translation: translationFA,
  },
};

export const PATIENT_TIMER_DURATION_SECONDS = 3 * 60;
